/*
 * @Author: along longwang6@163.com
 * @Date: 2025-06-16 20:19:55
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-06-27 15:22:18
 * @FilePath: /ehr-web/src/components/AuthHunterRoute/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 登录鉴权
 */
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import {
  checkLogin,
  // redirectToLogin,
  redirectToLoginHunter,
} from '@/utils/auth';
import { useEffect, useState } from 'react';
import { useStore } from '@/store';
import { Spin } from '@arco-design/web-react';
// import Pattern from '@/constants/pattern';
// import { LocalStorageKey } from '@/constants/storage';

interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const location = useLocation();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // const user = useStore('user');
  const { userInfo } = useStore('userHunter');

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isLoggedIn = await checkLogin();
        setIsAuthenticated(isLoggedIn);
        if (!isLoggedIn) {
          // 如果当前已经在登录页面，不要再次跳转
          if (location.pathname.includes('/loginHunter')) {
            setIsLoading(false);
            return;
          }

          // 检查是否是手动退出登录（通过 URL 参数或 localStorage 标记判断）
          const urlParams = new URLSearchParams(window.location.search);
          const isManualLogout = urlParams.get('logout') === 'true';
          const hasLogoutFlag =
            localStorage.getItem('hunter_logout_flag') === 'true';

          // 如果是手动退出登录，直接返回，不要再次跳转
          if (isManualLogout || hasLogoutFlag) {
            // 清除退出标记
            localStorage.removeItem('hunter_logout_flag');
            setIsLoading(false);
            return;
          }

          // 其他情况，添加 redirect 参数
          redirectToLoginHunter(true);
        }
        // 等待用户信息加载完成
        // await user.fetchPermissionList();
        // await setUserInfo()
      } catch (error) {
        console.error('Auth check failed:', error);
        redirectToLoginHunter(true);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [location.pathname, userInfo]);

  if (isLoading) {
    // 可以返回一个加载中的状态
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null; // 已经调用 redirectToLogin，这里返回 null
  }

  return <>{children}</>;
};

export default observer(AuthRoute);
